import React, { Component } from "react";
import ShopListItem from '../shop_list_item/shop_list_item';
import Flexbox from 'flexbox-react';
import {observer, inject} from 'mobx-react';


const mainDivWidths = {
  image: "19%",
  body: "61%",
  status: "19%"
};

const shopListItemWrapper = {
  "display":"inline-block",
  "width": "100%",
  "height": "14.6%",
  "color": "rgba(0, 0, 0, 0.87)"
};

@inject('RootStore')
@observer
export default class HallPanelShopList extends Component {

  render() {
    let currShops = [];
    let hallStore = this.props.RootStore.hallStore;
    for(let i=hallStore.currentSubListStartingIndex; i < hallStore.currentSubListEndingIndex; i++) {
      currShops.push(<Flexbox style={shopListItemWrapper} key={i}><ShopListItem shop={hallStore.shopsList[i]} componentWidths={mainDivWidths}/></Flexbox>);
      currShops.push(<Flexbox key={hallStore.currentSubListEndingIndex + i + 2} height="2%"></Flexbox>);
    }
    return (
      <Flexbox width="100%" height="100%" flexDirection="column">
        {currShops}
      </Flexbox>

    );
  }
}



// WEBPACK FOOTER //
// ./src/components/shop_panel/hall_panel_shop_list.jsx